import { Component, OnInit, ViewChild } from "@angular/core";
import { MdbTableDirective } from "ng-uikit-pro-standard";
import { AppService } from "src/app/core/app/app.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { OrderFactoryEventData } from "src/app/core/order/analytics/data/data.abstract";
import { VenueOrderFactory } from "src/app/core/order/order.factory.venue";
import { OrderFactory } from "src/app/core/order/order.factory";
import { OrderFactoryPeriodSummary } from "src/app/core/order/analytics/summaries/summary.abstract";

@Component({
  selector: "ll-summary-by-active-days",
  templateUrl: "./summary-by-active-days.component.html",
  styleUrls: ["./summary-by-active-days.component.scss"]
})
export class SummaryByActiveDaysComponent implements OnInit {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;

  public map: Map<number, string>;

  private _showing: number;
  private _firstIndex: number;
  private _lastIndex: number;
  public itemsPerPage: number[] = [5, 10, 25];
  constructor(private app: AppService, private router: Router) {
    this.map = new Map();
    this.map.set(0, "Sunday");
    this.map.set(1, "Monday");
    this.map.set(2, "Tuesday");
    this.map.set(3, "Wednesday");
    this.map.set(4, "Thursday");
    this.map.set(5, "Friday");
    this.map.set(6, "Saturday");
    this._showing = 10;
    this._firstIndex = 0;
    this._lastIndex = 10;
  }

  onItemsPerPageChange(n: number) {
    this._showing = n;
    this._firstIndex = 0;
    this._lastIndex = n;
  }

  onIncrement(n: number) {
    if (this._lastIndex >= n) return;
    this._firstIndex += this._showing;
    this._lastIndex += this._showing;
    if (this._lastIndex > n) this._lastIndex = n;
  }

  onDecrement(n: number) {
    if (this._firstIndex <= 0) return;
    this._firstIndex -= this._showing;
    this._lastIndex -= this._showing;
    if (this._firstIndex < 0) this._firstIndex = 0;
  }

  public get firstIndex(): number {
    return this._firstIndex < 0 ? 0 : this._firstIndex;
  }

  public get lastIndex(): number {
    return this._lastIndex < this._showing ? 0 : this._lastIndex;
  }

  public get showing(): number {
    return this._showing ?? 10;
  }

  ngOnInit() {}

  ngAfterViewInit(): void {}

  public get data$(): Observable<OrderFactoryEventData[]> {
    return this.app.state.eventTableData$;
  }

  public get totals$(): Observable<OrderFactoryPeriodSummary> {
    return this.app.state.periodTotalData$;
  }
}
